// extracted by mini-css-extract-plugin
module.exports = {"block":"Block_block__2o9BB","disabled":"Block_disabled__vyLg3"};